import {Pipe, PipeTransform} from '@angular/core';
import {UrlHelperService} from '@app/service/url-helper.service';

/**
 * Resolves a relative to an absolute path, relative to the language-independent application context path
 */
@Pipe({
	name: 'resourcePath',
	pure: true
})
export class ResourcePathPipe implements PipeTransform {
	readonly #basePath: string;

	constructor(urlHelper: UrlHelperService) {
		const nonLocalizedBasePath = urlHelper.getNonLocalizedBasePath();
		this.#basePath = ResourcePathPipe.stripTrailingSlash(nonLocalizedBasePath);
	}

	private static stripLeadingSlash(text: string): string {
		return text.replace(/^\//, '');
	}

	private static stripTrailingSlash(text: string): string {
		return text.replace(/\/$/, '');
	}

	transform(value: string): string {
		return this.#basePath + '/' + ResourcePathPipe.stripLeadingSlash(value);
	}
}
